import { Link, useLocation } from 'react-router-dom';

import Button from '../../../../shared/components/Button';
import { Card } from 'react-bootstrap';
import Price from '../../../../../frontend/components/components/utils/numbers/Price';
import PropTypes from 'prop-types';
import React from 'react';
import ReactTooltipWrapper from '../../../../../frontend/components/components/utils/ReactTooltipWrapper';
import { get } from 'lodash-es';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

function PaymentCard({ payments, extraPayments,
  isLogged,
  incentives,
  lumanuEnabled = false, lumanuEmail, showMoreDetails = true }) {
  const { t } = useTranslation();
  const location = useLocation();
  const offerId = useSelector(store => get(store, 'offer.offerId'));

  const extraPaymentsTitle = () => (
    <label className="text-1 mt-3" data-tip={t('influencers.common.extra_payment_tooltip')}>
      {t('influencers.pages.campaign.extra_payments')}
    </label>
  );

  const paymentsTitle = () => (
    <label className="text-1 mt-3" data-tip={t('influencers.common.payment_tooltip')}>
      {t('influencers.pages.campaign.payments')}
    </label>
  );

  return (<Card className="mb-2">
    <Card.Body className="text-1">
      <ReactTooltipWrapper
        tooltipProps={{
          type: "light",
          place: "top",
          effect: "solid",
          border: true
        }}
      >
        {paymentsTitle()}
      </ReactTooltipWrapper>
      {
        !isLogged ?
          <span >
            <Link className="link" to={{
              pathname: "/signin",
              state: { from: location.pathname }
            }}>
              {t('influencers.common.sign_in')}
            </Link>
            &nbsp;{t('influencers.pages.campaign.glance.to_see_structure')}
          </span>
          : <React.Fragment>
            <div>
              {
                incentives && incentives.payment_include == "on" ?
                  <div
                    dangerouslySetInnerHTML={{
                      __html: incentives.payment
                    }}>
                  </div>
                  : <div>
                    {
                      payments && payments.map(elem => (
                        <div key={elem.id} className="text-1 mt-1 text-underline">
                          <Price number={elem.user_payment_value || 0} currency={elem.currency} />
                        </div>
                      ))
                    }
                    <br />
                    {extraPayments && extraPayments.length > 0 &&
                      <ReactTooltipWrapper
                        tooltipProps={{
                          type: "light",
                          place: "top",
                          effect: "solid",
                          border: true
                        }}
                      >
                        {extraPaymentsTitle()}
                      </ReactTooltipWrapper>
                    }
                    {
                      extraPayments && extraPayments.map(elem => (
                        <div key={elem.id} className="text-1 mt-1 text-underline">
                          <Price number={elem.amount || 0} currency={elem.currency} />
                        </div>
                      ))
                    }
                  </div>
              }
            </div>
          </React.Fragment>
      }
      {lumanuEnabled && <p className="mt-2 small gray"><i>{t('influencers.pages.campaign.apply_side_pane.lumanu_payment_acknowledgment')}</i></p>}
      <p className="mt-2 small gray"><i>
        {lumanuEmail ?
          <React.Fragment>
            {t('influencers.pages.campaign.apply_side_pane.lumanu_payment_email', { email: lumanuEmail })}
            <Link to="/profile" className='text-2' style={{ 'font-style': 'italic' }}>{t('influencers.pages.campaign.apply_side_pane.user_profile')}</Link>.
          </React.Fragment>
          : <React.Fragment>
            {t('influencers.pages.campaign.apply_side_pane.lumanu_not_payment_email')}
            <Link to="/profile" className='text-2' style={{ 'font-style': 'italic' }}>{t('influencers.pages.campaign.apply_side_pane.user_profile')}</Link>.
          </React.Fragment>
        }
      </i></p>
    </Card.Body>
    {
      isLogged ?
        <Card.Footer>
          { showMoreDetails &&
          <Button to={`/offer/${offerId}/questions#payment_details`} as={Link} variant="tertiary" >
            <span className='text-underline'>{t('influencers.pages.campaign.more_details')}</span>
            <i className="fal fa-arrow-right icon-right"></i>
          </Button> }
        </Card.Footer> : null
    }
  </Card>);
}

PaymentCard.propTypes = {
  payments: PropTypes.array.isRequired,
  isLogged: PropTypes.bool,
  extraPayments: PropTypes.array,
};

PaymentCard.defaultProps = {
  isLogged: false
};

export default React.memo(PaymentCard);
